"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styledComponents = require("styled-components");

/**
 * Opacity Glow Keyframe animation
 *
 * @param {Number} opacity
 * @returns
 */
const fadeIn = () => {
  return (0, _styledComponents.keyframes)`
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    `;
};

var _default = fadeIn;
exports.default = _default;